/*
 * Demo content for FabricJS.
 */


const demoContent = async (canvas, fabric) => {
  
}


export default demoContent
